/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from '@servicetitan/application-data/common-interfaces';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IUserApi {
    get(cancelToken?: CancelToken): AxiosPromise<UserModel>;
}

export const BASE_URL_TOKEN_UserApi = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class UserApi implements IUserApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@inject(BASE_URL_TOKEN_UserApi) @optional() private readonly baseUrl = "") {
    }

    get(cancelToken?: CancelToken): AxiosPromise<UserModel> {
        let url_ = "/app/api/data/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<UserModel>(options_));
    }
}

export interface UserModel {
    userId?: number | undefined;
    employeeId?: number | undefined;
    userName?: string | undefined;
    userRole?: BuiltInUserRole | undefined;
    userCreatedOn?: Date | undefined;
    name?: string | undefined;
    avatar?: string | undefined;
    phone?: string | undefined;
    passwordExpired: boolean;
    passwordExpirationDueDays: number;
    isExternalUser: boolean;
    hasTitanAccess: boolean;
    isImpersonatedUser: boolean;
    isTemporaryPassword: boolean;
    isShowPasswordExperience: boolean;
    authenticationTicketId?: string | undefined;
    isMultipleLoginsAllowed: boolean;
    permissions: Permissions[];
}

export enum BuiltInUserRole {
    Unspecified = 0,
    Technician = 1,
    Dispatch = 2,
    Accounting = 6,
    FieldManager = 10,
    DisplayUser = 16,
    DisplayUserWithBillingAccess = 48,
    SalesManager = 64,
    CSR = 128,
    GeneralOffice = 256,
    TechnicianHelper = 512,
    TechnicianMaintenance = 1536,
    TechnicianInstaller = 3584,
    Admin = 4103,
    TechnicianService = 11776,
    TechnicianSales = 28160,
    Owner = 69639,
    EmptyEmployee = 131072,
    EmptyTechnician = 262144,
}

export enum Permissions {
    ViewAlerts = 10,
    EditAlerts = 11,
    ViewCustomer = 12,
    EditCustomer = 13,
    ViewCustomerStatement = 14,
    ViewLocation = 15,
    EditLocation = 16,
    ViewEstimate = 17,
    EditEstimate = 18,
    SoldEstimate = 19,
    ViewInvoice = 20,
    EditInvoice = 21,
    CreatePayment = 22,
    DeletePayment = 23,
    EditPaymentWithSavedAuthorizationCode = 24,
    EditInvoiceItem = 25,
    DeleteInvoiceItem = 26,
    EditPurchaseOrder = 27,
    DeletePurchaseOrder = 28,
    EditPayrollAdjustment = 29,
    DeletePayrollAdjustment = 30,
    EditAdjustmentInvoice = 31,
    DeleteAdjustmentInvoice = 32,
    EmailInvoice = 33,
    ChargeInterest = 34,
    ViewBatch = 35,
    CreateBatch = 36,
    PostBatch = 37,
    UnpostBatch = 38,
    BookJob = 39,
    ViewJob = 40,
    EditJob = 41,
    RescheduleJob = 42,
    HoldJob = 43,
    CancelJob = 44,
    RecallJob = 45,
    ViewJobCompletionSurvey = 46,
    EditJobCompletionSurvey = 47,
    DownloadJobAttachment = 48,
    UploadJobAttachment = 49,
    DeleteJobAttachment = 50,
    ViewPlumbingCheckup = 51,
    EditPlumbingCheckup = 52,
    AssignTechnician = 53,
    DetachSms = 54,
    DetachCall = 55,
    ViewScheduledReport = 56,
    EditScheduledReport = 57,
    DeleteScheduledReport = 58,
    ViewAllScheduledReports = 59,
    RunSearch = 60,
    ViewDispatchBoard = 61,
    AddNonJobAppointment = 62,
    EditNonJobAppointment = 63,
    SendMessage = 64,
    ViewDispatchConfiguration = 65,
    EditDispatchConfiguration = 66,
    ViewInvoiceNumbers = 67,
    AddInvoiceAssignment = 68,
    RemoveInvoiceAssignment = 69,
    AddVoidedInvoice = 70,
    RemoveVoidedInvoice = 71,
    ViewDashboard = 72,
    ListenToCallRecording = 73,
    OutboundCall = 74,
    ReclassifyCall = 75,
    ConfirmCall = 76,
    DeleteNote = 77,
    AccessRemotely = 78,
    ViewTimesheet = 79,
    EditTimesheet = 80,
    ViewBillingOrUpdateCreditCard = 81,
    UpdateForwardCallsToNumberOnSettingsPhone = 82,
    ViewOrUpdatePayrollTabOnTechnicianEdit = 83,
    ViewOrUpdateUserEmployeePermissions = 84,
    ViewOrUpdateAnotherUserUsernameOrPassword = 85,
    EditBusinessUnits = 86,
    ViewPayrollTabOnTechnicianEdit = 87,
    ViewBusinessUnits = 88,
    GetApiKey = 89,
    EditBusinessHoursAndCapacityPlanning = 90,
    PauseCallRecording = 91,
    ApplyPaymentCredit = 92,
    SavePaymentAndAddToBatch = 93,
    UnapplyPaymentCredit = 94,
    UnapplyExportedTransactions = 95,
    ViewPayrollAdjustment = 96,
    CreateCreditMemo = 97,
    EditCreditMemo = 98,
    ViewAccountingReports = 128,
    ViewDwyerReports = 129,
    ViewOperationsReports = 130,
    ViewOtherReports = 131,
    ViewMarketingReports = 132,
    ViewTechnicianReports = 133,
    ViewSoldByReports = 134,
    ViewInventoryReports = 135,
    EditAccountingReports = 136,
    EditOperationsReports = 137,
    EditOtherReports = 138,
    EditMarketingReports = 139,
    EditTechnicianReports = 140,
    EditSoldByReports = 141,
    EditInventoryReports = 142,
    AddMealBreak = 256,
    DispatchTechnician = 257,
    ArriveTechnician = 258,
    MarkTechnicianAsDone = 259,
    AttachJobToProject = 260,
    DetachJobFromToProject = 261,
    EditPrice = 262,
    EditTax = 263,
    EditNote = 264,
    DownloadProjectAttachment = 265,
    UploadProjectAttachment = 266,
    DeleteProjectAttachment = 267,
    EditService = 270,
    EditMaterial = 271,
    EditEquipment = 272,
    EditCategory = 273,
    ImportOrExportData = 274,
    MergeLocations = 275,
    MergeCustomers = 276,
    EditDiscountsAndFees = 277,
    ViewPricebook = 278,
    CalculatePrices = 279,
    ModifyEquipmentCost = 280,
    EditExportedInvoicesAndPayments = 281,
    ViewCallFormsAndTags = 282,
    EditCallFormsAndTags = 283,
    EditCustomerForms = 284,
    EditLocationForms = 285,
    EditEquipmentForms = 286,
    ViewItemPrices = 289,
    EditServicePrice = 290,
    EditEquipmentPrice = 291,
    EditMaterialPrice = 292,
    EditMaterialCharge = 293,
    EditCompanyProfile = 300,
    EditEmployee = 301,
    EditCampaign = 302,
    EditPhone = 303,
    EditCallReason = 304,
    EditJobType = 305,
    EditCancelJobReason = 306,
    EditHoldJobReason = 307,
    EditZone = 308,
    EditTagType = 309,
    EditCustomFieldType = 310,
    EditPaymentType = 311,
    EditInvoiceType = 312,
    EditMembershipType = 313,
    EditRecurringServiceType = 314,
    EditTaxZone = 315,
    EditVendor = 316,
    EditEmailSetting = 317,
    EditTimesheetCode = 318,
    EditCustomerMembershipData = 319,
    ViewAndEditBurdenRate = 320,
    ActivateOrDeactivateEmployees = 321,
    EditFinancingLoans = 322,
    ViewEditSavedEstimates = 323,
    ViewJobCosting = 324,
    EditPayrollCustomFields = 325,
    EditIntacctAccount = 326,
    EditGlAccountsOnInvoices = 327,
    EditBusinessUnitsOnInvoiceItems = 328,
    BypassInvoices = 329,
    AllowEditTecnPerformanceOnAdjustmentInvoices = 330,
    EditArrivalWindow = 331,
    AllowSellMembershipFromCustomerOrLocationAndRenewFromMembershipRecord = 332,
    ManageAPIApplicationAccess = 335,
    GenerateAPIApplicationKey = 336,
    ManageIntegrationEnvironment = 337,
    AllowBulkLocationRecurringServiceEventDismissal = 340,
    AllowTechClockInAndClockOutOnDispatch = 350,
    EditTeams = 351,
    ActivatingOrDeactivatingLocation = 352,
    ActivatingOrDeactivatingCustomer = 353,
    AccessCrewSchedulingBoard = 354,
    AllowManageUserSessions = 355,
    SetTaxStatusByInvoiceItem = 400,
    AccessSettings = 404,
    AccessContentPortal = 410,
    DeactivateFollowUpLog = 411,
    AllowExportingSearchResults = 412,
    ShowCostDetails = 413,
    EditShippingInfoOnPurchaseOrders = 414,
    EditCostFieldForPurchaseOrderItems = 415,
    EditPurchaseOrderInSentAndPartiallyReceivedStatus = 416,
    AcademyCompanyAdmin = 419,
    RefundTransaction = 421,
    ExportDashboardDrilldown = 422,
    EditAccessToPartnerPortals = 423,
    ViewCustomReports = 424,
    EditCustomReports = 425,
    ChatCenterRead = 426,
    ChatCenterWrite = 427,
    EditCallScripts = 428,
    ViewTechnicianShifts = 429,
    EditTechnicianShifts = 430,
    EditSkills = 431,
    AccessToTechnicianPerformanceDataSet = 432,
    AccessToInvoicesDataSet = 433,
    AccessToJobsDataSet = 434,
    AccessToBusinessUnitPerformanceDataSet = 435,
    EditDashboard = 436,
    AccessToMasterPayFileDataSet = 437,
    AccessToTimesheetsDataSet = 438,
    EmployeeCanSetTaskStatusFromCompletedCanceledToAnother = 440,
    EmployeeCanSetSubtaskStatusFromCompletedCanceledToAnother = 441,
    EmployeeCanSetTaskStatusCompletedCanceled = 442,
    EmployeeCanSetSubtaskStatusCompletedCanceled = 443,
    TaskManagementAccessAllTasksAndSubtasks = 444,
    TaskManagementAccessSettings = 445,
    EditSmartDispatchSettings = 446,
    ReceiveSTPaymentAutoBatchingEmail = 447,
    ReceiveMobileCheckDepositMatchFailureEmails = 448,
    AccessCustomerPortalSetup = 449,
    AllowViewingAndManualEditingOfGP = 450,
    DeleteSuccessfulTransactionPayment = 451,
    AllowEditingBookingTargets = 452,
    AcceptNewFeatureTermsOfUse = 453,
    ViewHourlyPayOnTimesheetSummaryReport = 454,
    DoNotTrackUserActions = 455,
    ModifyDispatchBoardBehaviour = 456,
    RunTimeSlotTracing = 457,
    AbilityToSyncHubspot = 458,
    FollowUpsDataExport = 459,
    EditMarkupRules = 460,
    ReceiveBillingAlerts = 461,
    AllowAccessToAuditTrails = 462,
    AccessToProjectJobCostingDataSet = 463,
    EditSalesOpportunityAndSoldOnDates = 464,
    ManuallyAdjustCapacity = 465,
    ViewPayrollApproval = 466,
    ViewAllManagersPayrollApproval = 467,
    EditLoyaltyProgramOnCustomerOrLocation = 468,
    EditPhonesProAccounts = 469,
    AccessToMarketingProModule = 470,
    CanAccessGlobalPayrollSettings = 471,
    EditPaymentTerms = 472,
    AllowBulkBookingOfUpcomingAppointments = 473,
    AllowEditingOfReportingPermissions = 474,
    ViewRequisition = 475,
    EditRequisitionDemand = 476,
    EditRequisitionFulfillment = 477,
    CreatePurchaseOrder = 478,
    EditReceipt = 480,
    DeleteReceipt = 481,
    EditBill = 482,
    DeleteBill = 483,
    CreateReturn = 484,
    EditReturn = 485,
    DeleteReturn = 486,
    CreateAdjustment = 487,
    EditAdjustment = 488,
    DeleteAdjustment = 489,
    CreateTransfer = 490,
    EditTransfer = 491,
    DeleteTransfer = 492,
    ReceiveShipment = 493,
    ArManagement = 494,
    EditInventoryConfiguration = 495,
    AllowBypassBatch = 496,
    BulkChargeStatementBalance = 497,
    ViewAndEditLaborTypes = 509,
    CreateEditRateSheets = 510,
    ViewRateSheet = 511,
    EditCustomerAndLocationRateSheets = 512,
    EditInvoiceEstimateProjectRateSheets = 513,
    ViewBillPayment = 514,
    CreateAndEditBillPayment = 515,
    DeleteBillPayment = 516,
    ApproveBillPayment = 517,
    ViewAndEditOvertimeModule = 518,
    ViewAndEditPaidIdleTimeRule = 519,
    ViewAndEditConfigurablePayrollModule = 520,
    ViewAndEditPayrollFrequencies = 521,
    DeleteOpportunityAndEstimate = 522,
    MassReschedule = 523,
    EditSkillsOnIndividualJobs = 524,
    CreatePaymentRefund = 525,
    ViewAndEditPayrollCodes = 526,
    EditProjectStatus = 527,
    AccountingPeriodsSettings = 530,
    ViewAccountingPeriodsSettings = 531,
    EditAccountingPeriodsSettings = 532,
    ViewAuditTrail = 533,
    ViewDetailedLaborCosting = 534,
    AccountingPeriodsManagement = 540,
    ViewAccountingPeriods = 541,
    ViewAccountingPeriodDetails = 542,
    OpenPeriod = 543,
    ClosePeriod = 544,
    OpenTransactionType = 545,
    CloseTransactionType = 546,
    PauseOrResumeTechSmartDispatch = 562,
    EmployeeCanAccessTimeTracking = 570,
    ViewAndEditAllEmployeeTimesheets = 571,
    PauseOrResumeJobSmartDispatch = 572,
    CanManuallyTriggerPayrollUpdate = 573,
    CanCreateAppointmentsOnJob = 574,
    EditPointOfSaleSettings = 575,
    EmployeeCanEditOwnActivities = 576,
    SeePropertyData = 577,
    EditInvoiceSignatureRequirement = 578,
    AccessToPayrollProcessingModule = 579,
    AllowEditAndUpdateOfPreviouslyExportedTransactions = 580,
    TitanAdvisorAdmin = 581,
    TitanAdvisorUpdateGoals = 582,
    ViewVendorCredits = 583,
    CreateVendorCredits = 584,
    EditVendorCredits = 585,
    DeleteVendorCredits = 586,
    CreateBillsAndStatements = 587,
    ViewBillsAndStatements = 588,
    ViewTitanExchange = 589,
    ViewSecondChanceLeads = 590,
    CreateInventoryCount = 591,
    EditInventoryCount = 592,
    CompleteInventoryCount = 593,
    CancelInventoryCount = 594,
    EditAutoBatchingSettings = 595,
    JournalEntryView = 596,
    ViewCustomerPaymentsHub = 597,
    RemoveLocationEquipment = 598,
    ReviewInvoiceHub = 599,
    AssignInvoiceHub = 600,
    AssignUserRoles = 601,
    AddEditPurchaseOrderTypes = 602,
    AddEditReturnTypes = 603,
    AddEditTransferTypes = 604,
    AddEditInventoryTemplates = 605,
    AddEditTrucksAndWarehouses = 606,
    EditPurchasingInventoryConfiguration = 607,
    AccessPurchasingInventory = 608,
    ViewPurchaseOrdersTotals = 609,
    ViewPurchaseOrders = 610,
    ViewReturnsTotals = 611,
    ViewReturns = 612,
    AddSublocations = 613,
    EditSublocations = 614,
    AllowAccessToInventoryMobileApp = 615,
    ViewEditUserActivities = 616,
    CreateEditActivities = 617,
    ViewAdjustmentItemsCost = 618,
    EditInvoiceSummaryRequirement = 619,
    HideProjectFinancials = 620,
    ImaPoViewLineItemCost = 621,
    ImaPoEditLineItemCost = 622,
    ImaPoAllowQuickReceive = 623,
    ImaPoViewExpectedQuantities = 624,
    ViewEditGpsTimekeepingIntegrationSettings = 625,
    ViewMapOnTimesheetEditPage = 626,
    ViewResolveGpsTimesheetDiscrepancies = 627,
    ShowProjectFinancials = 628,
    ViewFleetPro = 629,
    ViewCompanyCases = 630,
    AllowCreditReBill = 631,
    EditSubmittedClaim = 632,
    AddVendorCatalogItemsToPricebookFromPurchaseOrder = 633,
    SearchVendorCatalogItemsInPurchaseOrder = 634,
    AccessChatSettings = 635,
    ManageAssemblies = 636,
    ProvideImpersonationConsent = 637,
    AllowDataChangeRequestsToSupport = 638,
    BulkDeleteTechnicianShifts = 639,
    ViewAndEditOngoingTimesheetEntryGuardrails = 640,
    EditInputBasedProposalTemplate = 641,
    ViewEditProposals = 642,
    ViewExternalPaymentsDashboard = 643,
    JournalEntryActionExcludeFromSyncing = 644,
    JournalEntryActionIncludeInSyncing = 645,
    JournalEntryActionRemoveSyncData = 646,
    Mobile = 1024,
    MobileBookJob = 1025,
    MobileRescheduleJob = 1026,
    MobilePricebookAccess = 1027,
    MobileViewMaterialCosts = 1028,
    MobileViewForms = 1030,
    MobileListenToCallRecording = 1040,
    MobileClockInAndOut = 1041,
    MobileViewScorecard = 1050,
    MobileViewManageOthersTimesheets = 1060,
    MobileSetFirstTimesheetStartOfDay = 1061,
    MobileViewCustomerRecord = 1100,
    MobileViewLocationRecord = 1101,
    MobileViewCustomerPhoneNumbers = 1102,
    MobileViewLocationPhoneNumbers = 1103,
    MobileViewCustomerEmails = 1104,
    MobileViewLocationEmails = 1105,
    MobileViewJobNotes = 1106,
    MobileViewJobAttachments = 1107,
    MobileViewLocationAttachments = 1108,
    MobileViewCustomerAttachments = 1109,
    MobileCheckInOut = 1110,
    MobileMealBreak = 1111,
    MobileBypassSignature = 1112,
    MobileAddOnCheckbox = 1113,
    MobileTechnicianJobSoldByAssigning = 1114,
    MobileEditPayment = 1115,
    MobileMarkEstimateAsRecommended = 1116,
    MobileAllowSwitchToTrainingMode = 1117,
    MobileSelfDispatching = 1118,
    MobileDoneForNowAccess = 1119,
    MobileAccessFollowUps = 1120,
    MobileViewHistoryTab = 1121,
    MobileViewScorecard2 = 1122,
    MobileUploadPhotosAndVideos = 1123,
    MobileEditEstimatesInFollowUp = 1124,
    MobileMakeEstimateNameRequired = 1125,
    MobilePurchaseOrderReceiptPhotoRequired = 1126,
    MobileAllowEditingSoldEstimates = 1127,
    MobilePlaceJobOnHold = 1128,
    MobileTechnicianIsAbleToDisputePayroll = 1130,
    MobileTechnicianIsAbleToViewApprovalFlow = 1131,
    MobileAllowSendingEmailsFromTechnicianEmailAddress = 1132,
    MobileSetNotesOnCustomerLocationOrJob = 1133,
    MobileAllowFormsDuplication = 1134,
    MobileViewEquipmentCosts = 1135,
    MobileEnablePhoneCapture = 1136,
    MobileEnableSignaturePortal = 1138,
    MobileSeePropertyData = 1139,
    MobileAllowJobCompletionWithOpenRequisition = 1140,
    MobileAllowTechnicianToSendPo = 1141,
    MobileAllowTechnicianToAddItemsNotOnTruck = 1142,
    MobileRequestAdditionalAppointmentForJob = 1143,
    MobileAllowTechnicianToReceivePo = 1144,
    MobileAllowUploadingAttachmentsAfterJobCompletedOrHold = 1145,
    MobileTechnicianRescheduleJobAppointment = 1146,
    MobileAllowTechnicianToCreateReturns = 1147,
    MobileAllowTechnicianToCreateItemRequests = 1149,
    MobileRequireInvoiceSummary = 1150,
    MobileAllowFieldMobileApp = 1151,
    MobileAllowClassicMobile = 1152,
    MobilePrintEstimate = 1153,
    MobileCreateEstimate = 1154,
    MobileDeleteEstimate = 1155,
    MobileSellEstimate = 1156,
    MobileAddEstimateAndInvoiceItem = 1157,
    MobileEditEstimateNameAndSummary = 1158,
    MobileEditItemDetails = 1159,
    MobileEditItemQuantity = 1160,
    MobileMarkEquipmentAsServiced = 1161,
    MobileViewTotalPrice = 1162,
    MobileEnableJobAssist = 1163,
    SalesProEnablePreJobBriefs = 1164,
    MobileViewEditProposals = 1165,
    MobileAllowAddServicesOnEquipmentTasking = 1166,
    MobileManageTimesheetsForTechniciansOnMyJob = 1167,
    MobileEditTimesheetsForOtherTechnicians = 1168,
    ViewSalesPro = 1169,
    MobileViewHistoricalDetails = 1170,
    MobileAllowClosingJobWithoutConfirmingFindings = 1171,
    MobileLimitHistoryVisibility = 1536,
    MobileHideSalesForms = 1537,
    MobileCrewLeadTechnicianActions = 1538,
    MobileAllowTechnicianToEditInvoiceTaxZone = 1539,
    MobileEditTimesheetActivities = 1540,
    MobileAllowCreateManualTimesheets = 1541,
    EditJobTypeAfterExport = 4096,
    EditProjectsBusinessUnit = 4097,
    SetProjectToCompletedStatus = 4098,
    SetProjectFromCompletedStatusToAnother = 4099,
    EmployeeCanEditUsersMessages = 4100,
    EmployeeCanDeleteUsersMessages = 4101,
    EmployeeCanViewProjectPortfolio = 4102,
    EmployeeCanEditProjectsType = 4103,
    EmployeeCanOverrideProjectsTypeSettingsOnProject = 4104,
    EmployeeCanAccessGlobalWorkBreakdownStructureSettings = 4105,
    EmployeeCanAccessWorkBreakdownStructureSettingsForProjects = 4106,
    MobileTechnicianAllowedToEditInternalMessages = 4301,
    MobileTechnicianAllowedToDeleteInternalMessages = 4302,
    EditWorkspaces = 4352,
    EditIbsGeneralLedgerAccountMapping = 4501,
    AccessFeatureConfigurations = 4521,
    AllowViewShareAndEditAllReportsAndDashboards = 4552,
    AccessBudgetingSettings = 4553,
    RescheduleAppointments = 4554,
    AddAppointments = 4555,
    GlsaConfigure = 4556,
    GlsaCSR = 4557,
    ReportingAllowExport = 4558,
    ReportingAccessBenchmarkReports = 4559,
    FleetProAccessLiveMap = 4650,
    FleetProAccessVehicleData = 4651,
    FleetProAccessAssetData = 4652,
    FleetProAccessDriverData = 4653,
    FleetProAccessCameraData = 4654,
    FleetProAccessEventReport = 4655,
    FleetProAccessAllReports = 4656,
    FleetProAccessReminders = 4657,
    FleetProAccessAlerts = 4658,
    FleetProAccessGroups = 4659,
    FleetProAccessGeofences = 4660,
    FleetProAccessServiceEntry = 4661,
    FleetProAccessDeviceData = 4662,
    AllowSendPayrollForEmployeeApproveOrDispute = 4750,
    AllowManagerApprovePayroll = 4751,
    AllowUndoManagerApprovedPayroll = 4752,
    AllowLockManagerApprovedPayroll = 4753,
    AllowUnlockPayroll = 4754,
    ViewUserAndRolePermissionsAuditLog = 5000,
    AllowManageMfa = 5001,
    ViewIntracompanyTransfers = 5002,
    ApproveRejectIntracompanyTransfers = 5003,
    PickIntracompanyTransfers = 5004,
    ShipReceiveIntracompanyTransfers = 5005,
    CancelIntracompanyTransfers = 5006,
    ManageEnterpriseHubSettings = 5100,
    AdaptiveCapacityEditSettings = 6000,
    AdaptiveCapacityEditRules = 6001,
    AdaptiveCapacityAvailabilityFilters = 6002,
    AccessAdaptiveCapacitySettings = 6003,
    AccessAdaptiveCapacityRules = 6004,
    ApplyCapacityManualAdjustments = 6005,
    ViewSalesProSettings = 7000,
    EditSalesProSettings = 7001,
}
